import { Input, InputGroup, InputLeftAddon } from '@chakra-ui/react'
import React, { Component } from 'react'
import {
  ListaDiretorioImagensProduto,
  ListaConfigProdutos,
  SalvarDiretorioImagensProduto,
  runVerificaAutenticacao,
  ListaTelasCRM,
} from '../../../services/api'
import Header from '../../../components/Header'
import {
  ButtonModal,
  ButtonSearch,
  CardFieldSearch,
  Container,
  ContainerImagemProduto,
  ContentFilter,
  ContentFilterAddFolder,
  ContentFilterSelectFolder,
  ContentFilterSelectSystem,
  ContentTables,
  ContentTablesGrid,
  ContentTablesGridCard,
  ImageLoading,
  ImageModalContentBody,
  InputModal,
  InputSearch,
  Modal,
  ModalContainerCardFooter,
  ModalContainerCardFooterControl,
  ModalContent,
  ModalContentBodyCardFields,
  ModalContentBodyCardFieldsField,
  ModalContentBodyCardFieldsFieldCustom,
  ModalContentBodyCardFieldsFieldInputFile,
  ModalContentCard,
  ModalContentCardBody,
  ModalContentCardBodyCardProd,
  ModalContentCardBodyCardProdBoxDesc,
  ModalContentCardBodyCardProdBoxImage,
  ModalContentCardBodyCardProdSearch,
  ModalContentCardHeader,
  ModalContentCardHeaderContent,
  ModalContentCardLoading,
  ModalContentCardLoadingContent,
  SelectSistema,
} from './styles'

const loading = '../../../images/loading.gif'
const folder_gold = '/images/icon_folder_orange.png'
const folder_red = '/images/icon_folder_red.png'

class ImagensProduto extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dados: [],
      dadosProduto: [],
      type: 1,
      view_modal: false,
      view_loading: false,
      loadingModal: false,
      edit: false,
      produto_pesquisado: null,
      produto_pesquisado_novo: null,
      produto_aberto: null,
      img_to_import: [],
      count_field_file: 8,
      codigo_usuario: JSON.parse(localStorage.getItem('authentication'))
        .codigo_usuario,
      codigo_vendedor: JSON.parse(localStorage.getItem('authentication'))
        .codigo_vendedor,

      control_inclusao: null,
      control_alteracao: null,
      control_exclusao: null,
      control_consulta: null,
    }
  }

  componentDidMount() {
    runVerificaAutenticacao()
    this.initial()
  }

  initial = async () => {
    await this.CarregaPermissoes()
    this.getLessons()
  }

  CarregaPermissoes = async () => {
    try {
      const response = await ListaTelasCRM.get(
        '/' + window.location.pathname.replace('/', '')
      )
      var data = response.data

      var codigo_tela = null
      for (var obj in data) {
        codigo_tela = obj
      }

      this.setState({
        codigo_tela: codigo_tela,
        control_inclusao: JSON.parse(localStorage.getItem('authentication'))
          .permissoes_usuario[codigo_tela].inclusao,
        control_alteracao: JSON.parse(localStorage.getItem('authentication'))
          .permissoes_usuario[codigo_tela].alteracao,
        control_exclusao: JSON.parse(localStorage.getItem('authentication'))
          .permissoes_usuario[codigo_tela].exclusao,
        control_consulta: JSON.parse(localStorage.getItem('authentication'))
          .permissoes_usuario[codigo_tela].consulta,
      })
    } catch (error) {
      console.log(Object.keys(error), error.message)
    }
  }

  getLessons = async () => {
    if (this.state.control_consulta != 'S') {
      alert('Permissão negada')
      return false
    }
    try {
      const response = await ListaDiretorioImagensProduto.get(
        '/' + this.state.type
      )
      var data = response.data

      this.setState({ dados: data })
    } catch (error) {
      console.log(Object.keys(error), error.message)
    }
  }

  selecionaPastaProduto = async (e) => {
    await this.setState({
      produto_aberto: e.target.attributes.data.value,
      edit: true,
      view_modal: true,
    })
    this.getDadosProduto()
  }

  getDadosProduto = async (type = null) => {
    this.setState({ loadingModal: true })
    if (type == 'produto_novo') {
      var codprod = this.state.produto_pesquisado_novo
    } else {
      var codprod = this.state.produto_aberto
    }

    try {
      const response = await ListaConfigProdutos.get('/' + codprod)
      var data = response.data

      var split_data = data.url_seo.split('-')
      split_data.pop()
      var url = split_data.join('-')

      if (this.state.type == 1) {
        var imgprod =
          'https://innovationbrindes.com.br/images/produtos/' +
          codprod +
          '/' +
          url +
          '-1-1.jpg'
      } else {
        var imgprod =
          'https://innovationbrindes.com.br/images/produto_loja/' +
          codprod +
          '/' +
          url +
          '-1-1.jpg'
      }

      this.setState({ dadosProduto: data, imgprod: imgprod })
      this.setState({ loadingModal: false })
    } catch (error) {
      this.setState({ loadingModal: false })
      console.log(Object.keys(error), error.message)
    }
    this.setState({ loadingModal: false })
  }

  PesquisaProduto = async (e) => {
    if (e.target.value.trim() == '') {
      this.setState({ produto_pesquisado: null })
    } else {
      this.setState({ produto_pesquisado: e.target.value })
    }
  }

  PesquisaProdutoNovo = async (e) => {
    if (e.target.value.trim() == '') {
      this.setState({ produto_pesquisado_novo: null })
    } else {
      this.setState({ produto_pesquisado_novo: e.target.value })
    }
  }

  salvarImagens = async () => {
    try {
      this.setState({ loadingModal: true })
      var codprod =
        this.state.produto_pesquisado_novo != null
          ? this.state.produto_pesquisado_novo
          : this.state.produto_pesquisado
      if (this.state.dadosProduto.url_seo != undefined && codprod) {
        if (window.confirm('Confirmar importação das imagens?')) {
          var split_data = this.state.dadosProduto.url_seo.split('-')
          split_data.pop()
          var url = split_data.join('-')

          var formData = new FormData() // Corrente vazio

          const count_field = Array.from(
            { length: parseInt(this.state.count_field_file) },
            (_, i) => i + 1
          )

          count_field.map((num) => {
            formData.append(
              'arquivo-' + num,
              document.getElementById('arquivo-' + num).files[0]
            )
            formData.append('nome-arquivo-' + num, url + '-' + num + '-' + num)
          })

          formData.append(
            'codigo_produto',
            this.state.produto_pesquisado_novo != null
              ? this.state.produto_pesquisado_novo
              : this.state.produto_pesquisado
          )
          formData.append('tipo_sistema', this.state.type)

          const response = await SalvarDiretorioImagensProduto.post(
            '',
            formData
          )
          var data = response.data

          if (data.mensagem == 'sucesso') {
            alert('Imagens importadas com sucesso')
            this.setState({ loadingModal: false })
            this.closeModal()
            window.location.reload()
          } else {
            this.setState({ loadingModal: false })
            alert('Erro na importação')
          }
        }
        this.setState({ loadingModal: false })
      } else {
        alert('Informe qual produto deseja atualizar.')
        this.setState({ loadingModal: false })
      }
      this.setState({ loadingModal: false })
    } catch (error) {
      this.setState({ loadingModal: false })
      console.log(Object.keys(error), error.message)
    }
  }

  SelecionaTipoSistema = async (e) => {
    await this.setState({
      type: parseInt(e.target.options[e.target.options.selectedIndex].value),
    })
    this.getLessons()
  }

  AddMaisImagem = async () => {
    if (this.state.count_field_file < 30) {
      this.setState({ count_field_file: this.state.count_field_file + 1 })
    }
  }

  RemoveImagem = async () => {
    if (this.state.count_field_file > 8) {
      this.setState({ count_field_file: this.state.count_field_file - 1 })
    }
  }

  closeModal = async () => {
    ;[1, 2, 3, 4, 5, 6, 7, 8].map((data) => {
      document.getElementById('arquivo-' + data).value = ''
    })

    this.setState({
      view_modal: false,
      produto_aberto: null,
      dadosProduto: [],
      imgprod: null,
      count_field_file: 8,
    })
  }

  render() {
    const { dados, produto_pesquisado, produto_aberto } = this.state
    const count_field = Array.from(
      { length: parseInt(this.state.count_field_file) },
      (_, i) => i + 1
    )
    return (
      <>
        <Container>
          <ContainerImagemProduto>
            <h1>
              IMAGENS{' '}
              <strong>PRODUTO {this.state.type === 1 ? 'SITE' : 'LOJA'}</strong>
            </h1>
          </ContainerImagemProduto>

          <Modal
            style={
              this.state.view_modal
                ? { transition: '0.4s', opacity: '1' }
                : { opacity: '0', zIndex: '-1' }
            }
          >
            <ModalContent
              style={
                this.state.view_modal
                  ? { transition: '0.3s', transform: 'scale(1,1)' }
                  : { transform: 'scale(0,0)' }
              }
            >
              <ModalContentCard>
                <ModalContentCardLoading
                  style={
                    this.state.loadingModal
                      ? { transition: '0.3s', transform: 'scale(1,1)' }
                      : { transform: 'scale(0,0)' }
                  }
                >
                  <ModalContentCardLoadingContent>
                    <ImageLoading alt="loading" src={loading} />
                  </ModalContentCardLoadingContent>
                </ModalContentCardLoading>
                <ModalContentCardHeader>
                  <ModalContentCardHeaderContent>
                    {produto_aberto != null ? (
                      <h1>
                        Pasta do produto: <strong>{produto_aberto}</strong>
                      </h1>
                    ) : (
                      <h1>Nova pasta de imagens</h1>
                    )}

                    <ButtonModal
                      color="black"
                      colorScheme="white"
                      onClick={() => this.closeModal()}
                    >
                      Fechar
                    </ButtonModal>
                  </ModalContentCardHeaderContent>
                </ModalContentCardHeader>

                <ModalContentCardBody>
                  {this.state.dadosProduto.length != 0 ? (
                    <ModalContentCardBodyCardProd>
                      <ModalContentCardBodyCardProdBoxImage>
                        <ImageModalContentBody src={this.state.imgprod} />
                      </ModalContentCardBodyCardProdBoxImage>
                      <ModalContentCardBodyCardProdBoxDesc>
                        <p>
                          Produto:{' '}
                          <strong>{this.state.dadosProduto.nome}</strong>
                        </p>
                        <br />
                        <p>
                          Características:{' '}
                          <strong>
                            {this.state.dadosProduto.caracteristicas.length >
                            100
                              ? this.state.dadosProduto.caracteristicas.substring(
                                  0,
                                  100
                                ) + '...'
                              : this.state.dadosProduto.caracteristicas}
                          </strong>
                        </p>
                        <br />
                        <p>
                          Dimensões:{' '}
                          <strong>{this.state.dadosProduto.dimensoes}</strong>
                        </p>
                        <br />
                        <p>
                          Quantidade de imagens:{' '}
                          <strong>
                            {this.state.dadosProduto.quantidade_imagens}
                          </strong>
                        </p>
                        <br />
                      </ModalContentCardBodyCardProdBoxDesc>
                    </ModalContentCardBodyCardProd>
                  ) : (
                    <ModalContentCardBodyCardProdSearch>
                      <CardFieldSearch>
                        <InputGroup>
                          <InputLeftAddon
                            bgColor="white"
                            children="Buscar produto:"
                          />
                          <InputSearch
                            opacity="0.8"
                            borderColor="#313131 "
                            type="text"
                            placeholder="Pesquisar..."
                            _hover={{
                              borderColor: '#313131',
                              opacity: 1,
                            }}
                            focusBorderColor="#313131"
                            onChange={(e) => this.PesquisaProdutoNovo(e)}
                          />
                        </InputGroup>
                        <ButtonSearch
                          opacity="0.9"
                          _hover={{
                            backgroundColor: '#313131',
                            opacity: 1,
                          }}
                          bgColor="#313131"
                          onClick={() => this.getDadosProduto('produto_novo')}
                          w="40%"
                          h="2.5rem"
                        >
                          Buscar
                        </ButtonSearch>
                      </CardFieldSearch>
                    </ModalContentCardBodyCardProdSearch>
                  )}
                  <ModalContentBodyCardFields>
                    {count_field.map((num) => {
                      return (
                        <ModalContentBodyCardFieldsField>
                          <label>Imagem {num + '-' + num} : </label>
                          <ModalContentBodyCardFieldsFieldInputFile>
                            <InputModal
                              variant="outline"
                              id={'arquivo-' + num}
                              name={'arquivo-' + num}
                              type="file"
                              data-buttonText="Selecionar imagem"
                            />
                          </ModalContentBodyCardFieldsFieldInputFile>
                        </ModalContentBodyCardFieldsField>
                      )
                    })}

                    <ModalContentBodyCardFieldsFieldCustom>
                      <button onClick={() => this.AddMaisImagem()}>
                        MAIS IMAGENS
                      </button>
                      <button onClick={() => this.RemoveImagem()}>
                        MENOS IMAGENS
                      </button>
                    </ModalContentBodyCardFieldsFieldCustom>
                  </ModalContentBodyCardFields>
                </ModalContentCardBody>
                <ModalContainerCardFooter>
                  <ModalContainerCardFooterControl>
                    <label>
                      Clique no 'Salvar' para confirmar a importação{' '}
                    </label>
                    <button onClick={() => this.salvarImagens()}>Salvar</button>
                  </ModalContainerCardFooterControl>
                </ModalContainerCardFooter>
              </ModalContentCard>
            </ModalContent>
          </Modal>

          <ContentFilter>
            <ContentFilterSelectFolder>
              <InputGroup fontFamily="Akrobat" size="sm">
                <InputLeftAddon
                  bgColor="rgb(61, 61, 61)"
                  color="white"
                  children="PESQUISA:"
                />
                <Input
                  focusBorderColor="rgb(61, 61, 61)"
                  bgColor="white"
                  autoFocus
                  placeholder="Digite o número..."
                  name="numero_proposta"
                  type="number"
                  onChange={(e) => this.PesquisaProduto(e)}
                />
              </InputGroup>
            </ContentFilterSelectFolder>
            <ContentFilterAddFolder>
              <label>ADICIONAR NOVO</label>
              <button
                onClick={() =>
                  this.setState({ view_modal: !this.state.view_modal })
                }
              >
                <h1>+</h1>
              </button>
            </ContentFilterAddFolder>
            <ContentFilterSelectSystem>
              <label>SISTEMA:</label>
              <SelectSistema
                focusBorderColor="rgb(61, 61, 61)"
                onChange={(e) => this.SelecionaTipoSistema(e)}
              >
                <option value="1">Site Innovation</option>
                <option value="2">Lojas Innovation</option>
              </SelectSistema>
            </ContentFilterSelectSystem>
          </ContentFilter>
          <ContentTables>
            <ContentTablesGrid>
              {dados.map((data) => {
                if (
                  produto_pesquisado == null ||
                  data.nome_diretorio.indexOf(produto_pesquisado) != -1
                ) {
                  return (
                    <ContentTablesGridCard>
                      <img
                        alt="folders"
                        data={data.nome_diretorio}
                        onClick={(e) => this.selecionaPastaProduto(e)}
                        src={this.state.type == 1 ? folder_gold : folder_red}
                      />
                      <p>{data.nome_diretorio}</p>
                    </ContentTablesGridCard>
                  )
                }
              })}
            </ContentTablesGrid>
          </ContentTables>
        </Container>
      </>
    )
  }
}

export default ImagensProduto
